module.exports = __webpack_public_path__ + "img/task-edit.85fce1ea.png";